module.exports = function() {
  return new Worker(__webpack_public_path__ + "3326901e736c8df902ec.worker.js");
};